import React, { Fragment,useState } from 'react';
import { Container, Col, Row, Card, CardBody, Button, Input, Form, FormGroup } from 'reactstrap';
import { ModalExam } from '../../../components/exams/ModalExam';
import { useExam } from '../../../hooks/exams/useExam';
import { ModalIndicationExam } from '../../../components/exams/ModalIndicationExam';
import { ModalReleaseExam } from '../../../components/exams/ModalReleaseExam';
import { ModalExamImagenology } from '../../../components/exams/ModalExamImagenology';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { useRef } from 'react';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';

export const IndexExams = () => {
    const txtsection = localStorage.getItem('TextAS');
    const {
        exams, method, handleInputChange, validaciones,
        sections, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports,
        id_section, id_subsection, id_specimen_origin, code, alias, name, abbreviation, individual_sale, cost, is_referenced, print_new_page, listExternalLaboratories, is_critic,
        closeDialog, modal, modalTitle, loading, examId, getUpdateDefaultExternalLaboratory,
        changeSelect, handleSelectValues,
        handleCreate, saveCreate, saveUpdate,
        handleDelete, saveDelete,
        navigateCreateOrUpdateAnalytes, navigateMicroAnalytes,
        navigateConfigExam, navigateCostProduction, navigateCreateExamSimple, navigateEditExamSimple,
        handleChangePrice,
        goNextPage, goPreviousPage, goToPage, actualPage, totalPages,
        formValues, handleSearch,
        //INDICATION
        toggle2, modal2, handleListProfile, listIndications, indication, handleChangeIndication,
        id_exam_indication, indicationn, listIndication, selectIndication, removeExamProfile,
        CreateOrUpdateExamIndications,
        handleGetValidReleaseExam, releaseExam, modalReleaseExam, toggleRelease, loadingReleaseExam,
        saveUpdateStatusComplete,
        //filter
        is_referencedf, is_simplef, individual_salef, is_criticf, is_completef,
        handleInputChangeFilter, handleFilters, id_sectionf, listSection, handleChangeSection, clearFilter,
        handleSelectValuesIndication, dataIndication,
        //IMAGENOLOGIA
        methodImagenolofia, handleCreateExamImagenologia, titleImagenologia, modalImagenologia, toggleImagenologia,
        //nuevo_campo,nuevo_campo2
        sections2, number_projections, enable_analyte_configuration, handleUpdateImagenology,
        isImagenologyy, examEditIm, validationSectionArea,
        
        //*CONFIGURATION EXTERNAL LABORATORY
        dataLaboratory,handleChangePriceIni,

         // * CATALOG LAB
         dataIndicationLab,listIndicationLab,  handleInputChangeIndication2,handleSelectValuesIndication2, 

         // * Download Exam and Profile
         downloadExcel,

         // * curves
         showCurveField, is_curve, loadingSaveExam, handleSearchExam,
          closeDeleteAlert, openDeleteAlert, modalAlert,showDeleteAlert

    } = useExam();
    
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };
                                        
    const actions = (rowData) => {
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
          <div className="d-flex justify-content-center align-items-center" style={{ gap: "4px", marginRight: "3px" }} >
            {rowData.typeExam !== "Sencillo" && (
              <Button
                color="primary"
                size="sm"
                onClick={() => navigateConfigExam(rowData.id_exam)}
                title="Método del Exámen"
                style={{
                  padding: "2px",
                  fontSize: "1rem",
                  height: "26px",
                  width: "26px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="fa fa-cogs f-12"></i>
              </Button>
            )}

            {rowData.typeExam !== "Sencillo" && (
              <button
                size="sm"
                onClick={() => navigateCreateOrUpdateAnalytes(rowData.id_exam)}
                disabled={!rowData.has_method}
                title="Agregar Análito"
                style={{
                  padding: "2px",
                  fontSize: "1rem",
                  height: "26px",
                  width: "26px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: rowData.has_method ? "#1e6b8a" : "#9e9e9e",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: rowData.has_method ? "pointer" : "not-allowed",
                  opacity: rowData.has_method ? 1 : 0.7,
                }}
              >
                <i className="fa fa-cog f-12"></i>
              </button>
            )}

            <button
                  size="sm"
                  onClick={() => navigateCostProduction(rowData.id_exam)}
                  title="Costo de Producción"
                  style={{
                      padding: "2px",
                      fontSize: "1rem",
                      height: "26px",
                      width: "26px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#51bb25", 
                      color: "#fff",               
                      border: "none",             
                      borderRadius: "4px"          
                  }}
              >
                  <i className="icofont icofont-cur-dollar-plus"></i>
              </button>

              <button
                  size="sm"
                  onClick={() => handleGetValidReleaseExam(rowData.id_exam)}
                  title="Liberar examen"
                  style={{
                      padding: "2px",
                      fontSize: "1rem",
                      height: "26px",
                      width: "26px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#01839d", 
                      color: "#fff",               
                      border: "none",             
                      borderRadius: "4px"          
                  }}
              >
                  <i className="fa fa-check f-12"></i>
            </button>
        
            <button
              size="sm"
              onClick={() => navigateEditExamSimple(rowData.id_exam)}
              title="Editar Exámen"
              style={{
                padding: "2px",
                fontSize: "1rem",
                height: "26px",
                width: "26px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#1875c5",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
              }}
            >
              <i className="fa fa-edit f-12"></i>
            </button>

            <button
              size="sm"
              onClick={() => handleListProfile(rowData.id_exam)}
              title="Indicaciones del Exámen"
              style={{
                padding: "2px",
                fontSize: "1rem",
                height: "26px",
                width: "26px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#016392",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
              }}
            >
              <i className="icofont icofont-prescription"></i>
            </button>

            <Button
              color="danger"
              size="sm"
              onClick={() => handleDelete(rowData.id_exam)}
              style={{
                padding: "2px",
                fontSize: "1rem",
                height: "26px",
                width: "26px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>

          {rowData.typeExam !== "Sencillo" && !rowData.has_method && (
            <div
              style={{
                color: "#856404",             
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd", 
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              Agrega un método para habilitar la opción de “Agregar Analito(s)”
            </div>
          )}


        </div>
      );
    };


    const menu = useRef(null);

    const items = [
        {
            label: 'Examen sencillo',
            icon: 'fa fa-plus-circle',
            command: () => navigateCreateExamSimple()
        },
        {
            label: 'Examen complejo',
            icon: 'fa fa-plus-circle',
            command: () => handleCreate()
        },
        // {
        //     label: 'Examen Imagen',
        //     icon: 'icofont icofont-heartbeat',
        //     command: () => handleCreateExamImagenologia()
        // }
    ];

    const header = (
        <div
            className="d-flex align-items-center justify-content-between w-100 mt-1"
            style={{ marginBottom: "1rem" }}
        >
            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                <Button
                    type="button"
                    size="sm"
                    className="p-button-outlined p-button-primary btn-pill d-flex align-items-center"
                    onClick={(e) => menu.current.toggle(e)}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        height: "30px",
                        fontSize: "0.85rem",
                    }}
                >
                    <i className="fa fa-plus" /> 
                </Button>

                <Menu
                    model={items}
                    popup
                    ref={menu}
                    id="popup_menu"
                    style={{
                        marginTop: "4px",
                        marginLeft: "-10px",
                        borderRadius: "10px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    }}
                    className="custom-popup-menu"
                />

                <Button
                    color="success"
                    onClick={downloadExcel}
                    size="sm"
                    title="Exportar a Excel"
                    style={{
                        padding: "2px 10px",
                        height: "30px",
                        fontSize: "0.85rem",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                    }}
                >
                    <i className="pi pi-file-excel" />
                </Button>
            </div>

            <div>
                <Input
                    placeholder="Buscar examen..."
                    className="form-control form-control-sm"
                    onChange={handleSearch}
                    style={{
                        width: "250px",
                        borderRadius: "8px",
                    }}
                />
            </div>
        </div>
    );

        
            


    return (
        <Fragment>
            <div >
                <Row>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">
                        <Card style={{paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", scrollBehavior: "smooth", transform: "scale(0.8)", width: "125%", transformOrigin: "top left", textAlign: "justify"}}>
                            <CardBody className="p-1">
                                <div style={{ 
                                        backgroundColor: '#1a7dbbff', 
                                        color: '#fff', 
                                        padding: '5px 10px', 
                                        borderRadius: '8px', 
                                        marginBottom: '10px', 
                                        fontWeight: 'bold', 
                                        textAlign: 'center',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }}>
                                       
                                       <h6>
                                        EXAMENES CLINICOS
                                        
                                        </h6>

                                </div>
 

                                <br />                        

                                <div className="table-responsive">
                                    <DataTable
                                        value={exams}
                                        lazy
                                        paginator
                                        first={(actualPage - 1) * 10} 
                                        rows={10}
                                        totalRecords={totalPages * 10} 
                                        onPage={(e) => goToPage(e.page + 1)}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "25%" }} alt="Sin Examenes" />
                                                <br />
                                                <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                    Sin Examenes.
                                                </p>
                                            </div>
                                        }
                                        // rowsPerPageOptions={[10, 50, 100]}
                                        responsiveLayout="scroll"
                                        header={header}
                                    >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="code" header="Clave"  headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="abbreviation" header="Abreviatura"  headerStyle={headerStyle} style={cellStyle}/>
                                        <Column
                                            field="individual_sale"
                                            header="Venta individual"
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                            body={(rowData) => (rowData.individual_sale ? "SI" : "NO")}
                                        
                                        />
                                        <Column field="name_section" header="Sección/Área" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="name_specimen" header="Especimen" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="is_complete" header="Examen terminado" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="typeExam" header="Tipo de examen" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={cellStyle} />
                                    </DataTable>

                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar Exámen"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el exámen?"
                    alert1={true}
                    titleAlert1={name}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                    
                />
            
            )}

            <ModalExam
                {
                ...{
                    formValues, method, handleInputChange, validaciones, handleSelectValues, 
                    sections, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports,
                    id_section, id_subsection, id_specimen_origin, code, alias, name, abbreviation, individual_sale, cost, is_referenced,
                    closeDialog, modal, modalTitle, loading, listExternalLaboratories, examId, getUpdateDefaultExternalLaboratory, is_critic,
                    print_new_page,
                    changeSelect,
                    saveCreate,
                    saveUpdate,
                    saveDelete,
                    handleChangePrice, isImagenologyy, validationSectionArea,
                    //*CONFIGURATION EXTERNAL LABORATORY
                    dataLaboratory,handleChangePriceIni,
                    showCurveField, is_curve, loadingSaveExam

                }
                }
            />

            <ModalIndicationExam
                {
                ...{
                    toggle2, modal2,modalTitle, loading,method,
                    // ? INDICATIONS PATIENT
                    listIndication,CreateOrUpdateExamIndications,handleSelectValuesIndication,dataIndication,
                    // ? INDICATIONs LABORATORY
                    dataIndicationLab,listIndicationLab,handleSelectValuesIndication2
                }
                }
            />

            <ModalReleaseExam
                {
                ...{
                    releaseExam, modalReleaseExam, toggleRelease, loadingReleaseExam,
                    saveUpdateStatusComplete
                }
                }
            />

            <ModalExamImagenology
                {
                ...{
                    methodImagenolofia, handleCreateExamImagenologia, titleImagenologia, modalImagenologia, toggleImagenologia,
                    formValues, method, handleInputChange, validaciones, handleSelectValues,
                    sections, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports,
                    id_section, id_subsection, id_specimen_origin, code, alias, name, abbreviation, individual_sale, cost, is_referenced,
                    closeDialog, modal, modalTitle, loading, listExternalLaboratories, examId, getUpdateDefaultExternalLaboratory, is_critic,
                    changeSelect,
                    saveCreate, handleChangePrice,
                    saveDelete, sections2, number_projections, enable_analyte_configuration, handleUpdateImagenology,
                    isImagenologyy, saveUpdate, examEditIm,
                    //*CONFIGURATION EXTERNAL LABORATORY
                    dataLaboratory,handleChangePriceIni
                }
                }
            />
        </Fragment >
    )
}
